import { useIntl } from '@services/i18n';
import { OsciloEstadoTipoEnum } from "@/model/oscilo";

export function getNombreOsciloEstadoTipo(idOsciloEstadoTipo: number): string {
    const intl = useIntl();
    switch (idOsciloEstadoTipo) {
        case OsciloEstadoTipoEnum.NoInicializado:
            return intl.i18n.t('oscilos.popup_cajita_oscilo.estado_tipo.no_inicalizado');
        case OsciloEstadoTipoEnum.Funcionando:
            return intl.i18n.t('oscilos.popup_cajita_oscilo.estado_tipo.funcionando');
        case OsciloEstadoTipoEnum.Standby:
            return intl.i18n.t('oscilos.popup_cajita_oscilo.estado_tipo.standby');
        case OsciloEstadoTipoEnum.SucesoNuevo:
            return intl.i18n.t('oscilos.popup_cajita_oscilo.estado_tipo.suceso_nuevo');
        case OsciloEstadoTipoEnum.SucesoReciente:
            return intl.i18n.t('oscilos.popup_cajita_oscilo.estado_tipo.suceso_reciente');
        case OsciloEstadoTipoEnum.SucesoAntiguo:
            return intl.i18n.t('oscilos.popup_cajita_oscilo.estado_tipo.suceso_antiguo');
        case OsciloEstadoTipoEnum.Error:
            return intl.i18n.t('oscilos.popup_cajita_oscilo.estado_tipo.error');
        default:
            return "";
    }
}